import { AGE_GROUP_VOICE_CLONING } from '@src/constants/voiceCloning';

const useAgeGroupVoiceCloning = () => {
  const ageGroup = AGE_GROUP_VOICE_CLONING;

  const ageGroupOptions = Object.values(ageGroup)?.map((item) => ({
    label: item,
    value: item,
  }));

  return {
    ageGroup,
    ageGroupOptions,
  };
};

export default useAgeGroupVoiceCloning;
